package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import at.theatervogelweide.admin.contract.AdminError
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val callout = Bem("admin-callout")

// the design system's info circle: a 20-unit viewBox at stroke-width 1.6, sized by the styles, drawn with the text colour
private const val INFO_ICON =
    """<svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">""" +
        """<circle cx="10" cy="10" r="8"/><path d="M10 9v5M10 6.5v.01"/></svg>"""

/** A one-sentence note inside a card. [alert] makes screen readers announce it at once. */
@Composable
fun AdminCallout(alert: Boolean = false, content: @Composable () -> Unit) {
    Div({
        classes(callout.block)
        attr("role", if (alert) "alert" else "note")
    }) {
        Span({
            classes(callout.element("icon").className)
            attr("aria-hidden", "true")
            ref { element ->
                element.innerHTML = INFO_ICON
                onDispose { }
            }
        })
        Span({ classes(callout.element("text").className) }) { content() }
    }
}

/**
 * The optimistic-locking conflict (#11): someone else saved the record since it was loaded. [onReload] loads the
 * current version, which drops the changes made here.
 */
@Composable
fun AdminConflictCallout(onReload: () -> Unit, message: String = AdminError.conflict().message) {
    AdminCallout(alert = true) {
        Text("$message ")
        AdminButton(variant = ButtonVariant.LINK, onClick = onReload) { Text("Neu laden") }
        Text(" (deine Änderungen hier gehen dabei verloren)")
    }
}
